<div class="sac-begin-umbrueckung-dialog">

  <div class="dialog-layout">
    <sc-dialog-title>
      {{'swap trailer' | translate: ['tmc.sac-begin-umbrueckung-dialog.title', translationService.language]}}
    </sc-dialog-title>

    <div class="top-info">
      <app-transport-info-panel [carrier]="details.carrier" [identifier]="details.identifier" [driver]="details.name"
        [scope]="details.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content no-field-space">

      <sc-sub-title>
        {{'target transport details' | translate: ['tmc.sac-begin-umbrueckung-dialog.remaining-transport-details.title',
        translationService.language]}}
      </sc-sub-title>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <ng-container *ngIf="umbrueckungPossible">
        <div>
          <mat-form-field class="width-250" [hidden]="!isTrailerNumberVisible()" appearance="fill">
            <mat-label>{{'trailer numberplate' | translate: ['tmc.sac-begin-umbrueckung-dialog.trailerNumberPlate', translationService.language]}}</mat-label>
            <input name="trailerNumberPlate" matInput [(ngModel)]="details.trailerNumberPlate"
              [required]="isTrailerNumberPlateRequired()" [maxlength]="255">
          </mat-form-field>
        </div>
        <div *ngIf="isSwapTrailerEnabled()">
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <mat-form-field class="width-250" appearance="fill">
            <mat-label>{{'swap trailer number' | translate: ['tmc.sac-begin-umbrueckung-dialog.swapTrailerNumber', translationService.language]}}</mat-label>
            <input name="swapTrailerNumber" matInput [(ngModel)]="details.swapTrailerNumber"
              [required]="isSwapTrailerNumberRequired()" [maxlength]="255">
          </mat-form-field>
        </div>
      </ng-container>

      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>
    </div>

    <sc-padding>
      <sc-flex>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button class="cancel-button" (click)="closeDialog()"
          [disabled]="isCloseDialogDisabled()">{{'cancel' | translate:['tmc.sac-begin-umbrueckung-dialog.action.cancel',
          translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button class="confirm-button" mat-flat-button (click)="beginUmbrueckung()" [disabled]="isBeginUmbrueckungDisabled()"
          [matTooltip]="'swap trailer' | translate:['tmc.sac-begin-umbrueckung-dialog.action.begin', translationService.language]">
          {{'swap trailer' | translate:['tmc.sac-begin-umbrueckung-dialog.action.begin', translationService.language]}}
        </button>
      </sc-flex>
    </sc-padding>

    
  </div>
</div>